import { createContext, useContext } from "react";

// A read-only trip (its Trip Pass refunded or disputed, or its refund on its way: get_trip's `locked`): the
// server refuses every write to it but people leaving or being removed (and someone stopping sharing where
// they are), so the trip's screens offer none of the others (features/paying.md, "Spots"). Given by the
// trip's page around everything it shows.
export const ReadOnly = createContext(false);

export function useReadOnly(): boolean {
  return useContext(ReadOnly);
}
